// src/components/Admin/ChatManager/AdminChatLogManager.jsx

import { useState } from 'react';
import {
    Box, Tabs, Tab, Paper, Typography
} from '@mui/material';

import ChatLogPage from './Chat/ChatLogPage';          // ✅ 필터 포함된 완성형
import UserMessageStats from './Chat/UserMessageStats'; // ✅ 통계 전용

export default function AdminChatLogManager() {
    const [tab, setTab] = useState(0);

    return (
        <Box sx={{ p: 3 }}>
            <Typography variant="h5" gutterBottom>
                🛠 채팅 로그 & 통계
            </Typography>

            <Paper sx={{ mb: 3 }}>
                <Tabs
                    value={tab}
                    onChange={(_, v) => setTab(v)}
                    variant="fullWidth"
                    indicatorColor="primary"
                    textColor="primary"
                >
                    <Tab label="💬 메시지 로그" />
                    <Tab label="📊 유저별 채팅 통계" />
                </Tabs>
            </Paper>

            {/* 탭별 렌더링 */}
            {tab === 0 && <ChatLogPage />}
            {tab === 1 && <UserMessageStats />}
        </Box>
    );
}
